import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GroupEntry } from '@/types/applications';

// Everything tied to a single wave process across all steps
export interface WaveState {
  selectedClient: GroupEntry | null;
  selectedWaveOption: string;
  dataProcessingJobId: string | null;
  // Meta step: formatted JSON text. originalMeta is the meta in S3 (diff left side);
  // processedMeta is the processed meta incl. the user's edits (right side), which Publish uploads.
  originalMeta: string;
  processedMeta: string;
}

const initialState: WaveState = {
  selectedClient: null,
  selectedWaveOption: '',
  dataProcessingJobId: null,
  originalMeta: '',
  processedMeta: '',
};

export const waveSlice = createSlice({
  name: 'wave',
  initialState,
  reducers: {
    setSelectedClient(state, action: PayloadAction<GroupEntry | null>) {
      state.selectedClient = action.payload;
      // Wave options, any job and the meta belong to the client, so previous values are no longer valid.
      state.selectedWaveOption = '';
      state.dataProcessingJobId = null;
      state.originalMeta = '';
      state.processedMeta = '';
    },
    setSelectedWaveOption(state, action: PayloadAction<string>) {
      state.selectedWaveOption = action.payload;
      state.dataProcessingJobId = null;
      // The processed meta is generated for one wave.
      state.originalMeta = '';
      state.processedMeta = '';
    },
    setDataProcessingJobId(state, action: PayloadAction<string | null>) {
      state.dataProcessingJobId = action.payload;
    },
    setGeneratedMeta(state, action: PayloadAction<{ originalMeta: string; processedMeta: string }>) {
      state.originalMeta = action.payload.originalMeta;
      state.processedMeta = action.payload.processedMeta;
    },
    setProcessedMeta(state, action: PayloadAction<string>) {
      state.processedMeta = action.payload;
    },
  },
});

export const {
  setSelectedClient,
  setSelectedWaveOption,
  setDataProcessingJobId,
  setGeneratedMeta,
  setProcessedMeta,
} = waveSlice.actions;

export default waveSlice.reducer;
